interface CookieOptions {
  path?: string;
  expires?: Date;
  maxAge?: number;
  domain?: string;
  secure?: boolean;
  sameSite?: "Strict" | "Lax" | "None";
  httpOnly?: boolean;
}

export const getCookie = (name: string) => {
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=").map((c) => c.trim());
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
};

export const setCookie = (
  name: string,
  value: string,
  options: CookieOptions = {}
): void => {
  const {
    path = "/",
    expires,
    maxAge,
    domain,
    secure = false,
    sameSite = "Lax",
    httpOnly = false,
  } = options;

  try {
    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (path) cookie += `; path=${path}`;
    if (expires) cookie += `; expires=${expires.toUTCString()}`;
    if (maxAge) cookie += `; max-age=${maxAge}`;
    if (domain) cookie += `; domain=${domain}`;
    if (secure) cookie += `; secure`;
    if (httpOnly) cookie += `; httponly`;
    if (sameSite) cookie += `; samesite=${sameSite}`;

    document.cookie = cookie;
  } catch (error) {
    console.error("Error setting cookie:", error);
    throw new Error(`Failed to set cookie "${name}"`);
  }
};

export const deleteCookie = (name: string, path = "/") => {
  setCookie(name, "", {
    path,
    expires: new Date(0),
  });
};
